export default __webpack_public_path__ + "static/media/9704-ecommerce.372a5a93.gif";